<script>
	import Nav from "./Nav.svelte"
</script>

<header class="Header">
	<Nav />
	<div class="Header--presentation">
		<div class="Header--info">
			<p class="Header--info__p">
				Hola, soy Sergio Filoth y
			</p>
			<h1 class="Header--info__title">
				Te ayudo a llevar tu marca a la web
			</h1>
			<h2 class="Header--info__subtitle">
				El futuro esta en la web, no tardes en llegar.
			</h2>
			<a href="#cotization" class="btn">Pide tu cotización</a>
		</div>
		<div class="Header--img">
			<picture>
				<source media="(prefers-color-scheme: dark)" srcset="./img/darks/header.svg" alt="Web Developer">
				<img src="./img/header.svg" alt="Web Developer">
			</picture>
		</div>
	</div>
</header>
<style>
	.Header{
		background-color: var(--secundary);
		padding: 1rem 1rem 8rem;
	}
	.Header--info > *{
		margin-bottom: 1rem;
	}
	.Header--info__p{
		font-size: 1.4rem;
	}
	.Header--info__title{
		font-size: 4rem;
		font-weight: 900;
	}
	.Header--info__subtitle{
		font-weight: 400;
		font-size: 1rem;
		line-height: 1.75;
	}
	.Header--img{
		display: none;
	}
	@media screen and (min-width: 480px) {
		.Header{
			padding: 1rem 2rem 8rem;
		}
	}
	@media screen and (min-width: 768px) {
		.Header{
			padding: 3rem 2rem 8rem 3.5rem;
		}
		.Header--presentation{
			display: flex;
			justify-content: space-between;
		}
		.Header--info__title{
			width: 77%;
		}
		.Header--info__subtitle{
			width: 60%;
		}
	}
	@media screen and (min-width: 1024px) {
		.Header--img{
			min-width: 40%;
			display: block;
		}
		.Header--img > *{
			float: right;
		}
	}
</style>